import React from 'react';
import { Text, View, StyleSheet } from 'react-native';
import PropTypes from 'prop-types';
import { mappedTitles, mappedIcons } from '../utils';
import Theme from '../../theme';
import { moderateScale } from 'react-native-size-matters';
import { ProgramType } from 'fitbeat.models';

const WorkoutProgramModalTitle = ({ longTermGoal }) => (
  <View style={styles.titleContainer}>
    <View style={longTermGoal !== ProgramType.NotSet && styles.iconContainer}>
      {mappedIcons[longTermGoal]()}
    </View>
    <Text style={[
      styles.title,
      longTermGoal !== ProgramType.NotSet && styles.titlePaddingWithIcon]}>
      {mappedTitles[longTermGoal]}
    </Text>
  </View>
);

WorkoutProgramModalTitle.propTypes = {
  longTermGoal: PropTypes.string.isRequired,
};

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: 'row',
  },
  title: {
    fontWeight: '800',
    color: Theme.CHARCOAL,
    justifyContent: 'center',
    fontSize: moderateScale(20, 1),
  },
  titlePaddingWithIcon: {
    paddingLeft: 10,
  },
  iconContainer: {
    width: 30,
    height: 30,
  },
});

export default WorkoutProgramModalTitle;
